import React, {Component} from 'react';
import { putToast, adminloadTP, AuthenticatedUser, resolveAlert, stopTimer } from "../../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from '../tournamentPageTemplate'

class TournamentAdminAlerts extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.getTdProps = this.getTdProps.bind(this);
        this.onAlertUpdate = this.onAlertUpdate.bind(this);


        this.state = {
            loading: true,
            open: false,
            user: user,
            tData: {},
            pid: params.pid,
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            adminloadTP('alerts', 'none', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({tData: d2.tournamentPage, tUsers: d2.tUsers, alerts: d2.alerts, loading: false});                    

                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    getJudgeStatusColor(status) {
        switch(status.substring(0,3)) {
            case "Rea": return "font-success"
            case "Ava": return "font-warning"
            case "Set": return "font-danger"
            default: return "font-info"
        }
    }

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row && column.id !== "isResolved") {
            return {
                onClick: () => { 
                    /*
                    const roomId = rowInfo.original.roomId;
                    const judgeId = rowInfo.original.judge.userId;
                    this.props.history.push(`/tournament/ballot/room/judge/${this.state.tData._id}/${roomId}/${judgeId}`)
                    */
                },
                onMouseOver: (e) => {
                    this.setState({
                        selected: rowInfo.index
                    })
                },
                style: {
                    background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                    //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                }
            }
        } else { return {} }
    }

    
    onAlertUpdate(evt, talert) {
        const {alerts} = this.state;
        const val = evt.target.checked;
        
        resolveAlert(talert, val).then(d2 => {
            if (!d2 || d2.error) {
                console.log(d2 ? d2.error : "Error - no data");
                putToast.error(d2 ? d2.error : "Error - no data");
            } else {
                putToast.success(d2.message);
                alerts.find(x=>x.alertId === talert.alertId).isResolved = val;
                this.setState({alerts})
            }
        });    
    }
            
    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, user, alerts } = this.state;

            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Alerts - ${user.displayname}`} title3=""
                bcTitle="Alerts" bcParents={[
                    {name: tData.title, url: `/pages/tournament/${tData._id}`},
                    {name: "Administration", url: `/tournament/admin/${tData._id}`}
                ]}
            >              
                <div className="container-fluid">           
                    <div className="row">
                        <div className="col-sm-12">
                            <ReactTable
                                filterable
                                defaultFilterMethod={ (filter, row, column) => {
                                    const id = filter.pivotId || filter.id
                                    return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                }}
                                data={alerts}
                                columns={[{
                                    Header: 'Resolved?',
                                    accessor: 'isResolved',
                                    id: 'isResolved',
                                    style: { textAlign: 'center'},
                                    maxWidth: 100,                                   
                                    Cell: (row) => {
                                        return (
                                           <input
                                               type='checkbox'
                                               id={'isa'+row.original.alertId}
                                               checked={row.original.isResolved}
                                               onChange={(evt) => this.onAlertUpdate(evt, row.original)}
                                               style={{zoom: "1.2", width: "20px", height: "20px"}}
                                           />                                          
                                        )}
                                },{
                                    Header: 'Phone',
                                    accessor: 'phone',
                                    maxWidth: 130,                                   
                                },{
                                    Header: 'Displayname',
                                    accessor: 'displayname',
                                    maxWidth: 200,                                   
                                },{
                                    Header: 'Message',
                                    accessor: 'message',
                                    style: { 'whiteSpace': 'unset' }
                                }]}                                        
                                defaultPageSize={15}
                                showPagination={true}  
                                getTdProps={this.getTdProps}                                                                                                     
                            />
                        </div>
                    </div>  
                </div>
                          
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentAdminAlerts;